import { c as _c } from "react/compiler-runtime";
import { getPricingConfig } from "@/server/shop/get-shop-config";
export default function ProductPrice(t0) {
  const $ = _c(48);
  const {
    product,
    selectedVariant
  } = t0;
  const price = selectedVariant?.price || product?.variants?.[0]?.price || 0;
  selectedVariant?.display_price || product?.variants?.[0]?.display_price || 0;
  const priceInclVat = selectedVariant?.price_incl_vat || product?.variants?.[0]?.price_incl_vat || 0;
  const priceExclVat = selectedVariant?.price_excl_vat || product?.variants?.[0]?.price_excl_vat || 0;
  const comparePrice = selectedVariant?.compareprice || null;
  const {
    showVatBreakdown,
    vatDisplayFormat
  } = getPricingConfig();
  if (!showVatBreakdown) {
    let t1;
    if ($[0] !== price) {
      t1 = price.toFixed(2);
      $[0] = price;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== comparePrice || $[3] !== price) {
      t2 = comparePrice > price && <><del className="text-sm text-slate-600">£{comparePrice.toFixed(2)}</del><span className="bg-green-700 inline-flex px-2 py-1 rounded-md text-xs text-white">Save{" "}{Math.round((comparePrice - price) / comparePrice * 100)}%</span></>;
      $[2] = comparePrice;
      $[3] = price;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
      t3 = <div className="text-xl lg:text-3xl flex items-center gap-2"><ins className="font-bold no-underline text-red-700 flex items-center">£{t1}{t2}</ins></div>;
      $[5] = t1;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  if (vatDisplayFormat === "excl") {
    let t1;
    if ($[8] !== priceExclVat) {
      t1 = priceExclVat.toFixed(2);
      $[8] = priceExclVat;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    let t2;
    if ($[10] !== t1) {
      t2 = <span className="leading-none font-bold text-red-700 text-xl lg:text-3xl">£{t1}</span>;
      $[10] = t1;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="bg-gray-100 border border-gray-400 inline-flex text-xs px-1 font-medium rounded">excl. VAT</span>;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] !== comparePrice || $[14] !== price) {
      t4 = comparePrice > price && <><del className="text-sm text-slate-600">£{comparePrice.toFixed(2)}</del><span className="bg-green-700 inline-flex px-2 py-1 rounded-md text-xs text-white">Save{" "}{Math.round((comparePrice - price) / comparePrice * 100)}%</span></>;
      $[13] = comparePrice;
      $[14] = price;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    let t5;
    if ($[16] !== t2 || $[17] !== t4) {
      t5 = <div className="mb-1"><div className="flex items-end gap-2">{t2}{t3} dsdsdsd{t4}</div></div>;
      $[16] = t2;
      $[17] = t4;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  if (vatDisplayFormat === "incl") {
    let t1;
    if ($[19] !== priceInclVat) {
      t1 = priceInclVat.toFixed(2);
      $[19] = priceInclVat;
      $[20] = t1;
    } else {
      t1 = $[20];
    }
    let t2;
    if ($[21] !== t1) {
      t2 = <span className="leading-none font-bold text-red-700 text-xl lg:text-3xl">£{t1}</span>;
      $[21] = t1;
      $[22] = t2;
    } else {
      t2 = $[22];
    }
    let t3;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="bg-gray-100 border border-gray-400 inline-flex text-xs px-1 font-medium rounded">incl. VAT</span>;
      $[23] = t3;
    } else {
      t3 = $[23];
    }
    let t4;
    if ($[24] !== comparePrice || $[25] !== price) {
      t4 = comparePrice > price && <><del className="text-sm text-slate-600">£{comparePrice.toFixed(2)}</del><span className="bg-green-700 inline-flex px-2 py-1 rounded-md text-xs text-white">Save{" "}{Math.round((comparePrice - price) / comparePrice * 100)}%</span></>;
      $[24] = comparePrice;
      $[25] = price;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    let t5;
    if ($[27] !== t2 || $[28] !== t4) {
      t5 = <div className="mb-1"><div className="flex items-end gap-2">{t2}{t3}{t4}</div></div>;
      $[27] = t2;
      $[28] = t4;
      $[29] = t5;
    } else {
      t5 = $[29];
    }
    return t5;
  }
  let t1;
  if ($[30] !== priceExclVat) {
    t1 = priceExclVat.toFixed(2);
    $[30] = priceExclVat;
    $[31] = t1;
  } else {
    t1 = $[31];
  }
  let t2;
  if ($[32] !== t1) {
    t2 = <span className="leading-none font-bold text-red-700 text-xl lg:text-3xl">£{t1}</span>;
    $[32] = t1;
    $[33] = t2;
  } else {
    t2 = $[33];
  }
  let t3;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="bg-gray-100 border border-gray-400 inline-flex text-xs px-1 font-medium rounded">excl. VAT</span>;
    $[34] = t3;
  } else {
    t3 = $[34];
  }
  let t4;
  if ($[35] !== comparePrice || $[36] !== price) {
    t4 = comparePrice > price && <><del className="text-sm text-slate-600">£{comparePrice.toFixed(2)}</del><span className="bg-green-700 inline-flex px-2 py-1 rounded-md text-xs text-white">Save{" "}{Math.round((comparePrice - price) / comparePrice * 100)}%</span></>;
    $[35] = comparePrice;
    $[36] = price;
    $[37] = t4;
  } else {
    t4 = $[37];
  }
  let t5;
  if ($[38] !== t2 || $[39] !== t4) {
    t5 = <div className="flex items-end gap-2">{t2}{t3}{t4}</div>;
    $[38] = t2;
    $[39] = t4;
    $[40] = t5;
  } else {
    t5 = $[40];
  }
  let t6;
  if ($[41] !== priceInclVat) {
    t6 = priceInclVat.toFixed(2);
    $[41] = priceInclVat;
    $[42] = t6;
  } else {
    t6 = $[42];
  }
  let t7;
  if ($[43] !== t6) {
    t7 = <div className="text-sm mt-1 font-medium opacity-70">£{t6} incl. VAT</div>;
    $[43] = t6;
    $[44] = t7;
  } else {
    t7 = $[44];
  }
  let t8;
  if ($[45] !== t5 || $[46] !== t7) {
    t8 = <div className="mb-1">{t5}{t7}</div>;
    $[45] = t5;
    $[46] = t7;
    $[47] = t8;
  } else {
    t8 = $[47];
  }
  return t8;
}